import { Model, Factory, belongsTo } from 'miragejs'
import type { ModelDefinition } from 'miragejs/-types'
import { rand, randSoonDate, randPhrase } from '@ngneat/falso'

import type { SchemaAttributes } from '../types.js'
import type { MockServer } from './server.js'

export type ReminderData = SchemaAttributes<'Reminder'>

export const model = (Model as ModelDefinition<ReminderData>).extend({
  patient: belongsTo('patient'),
  reminderTemplate: belongsTo('reminderTemplate'),
})

export const factory = Factory.extend<ReminderData>({
  health_service_name() {
    return randPhrase({ maxCharCount: 30 })
  },
  email_subject() {
    return randPhrase({ maxCharCount: 40 })
  },
  expiry_date() {
    return randSoonDate({ days: 30 }).toISOString().split('T')[0]
  },
  send_before() {
    return rand([7, 14, 30])
  },
  send_method() {
    return rand(['EMAIL_AND_SMS', 'EMAIL', 'SMS'])
  },
  status() {
    return 'CREATED'
  },
})

export function routes(_server: MockServer) {
  // Reminders are served via the consultation next_actions endpoint
}

export function seeds(_server: MockServer) {
  // Reminders for the Next Steps section are seeded in Consultation.seeds()
}
